module.exports = __webpack_public_path__ + "img/benoit-havel.a9fcc56b.jpg";